
(function() {
  'use strict';

  function addHeaderHoverActive() {
    var header = document.querySelector('.header');
    if (header && header.classList.contains('header--transparent')) {
      header.classList.add('header--hover-active');
    }
  }

  function removeHeaderHoverActive() {
    var header = document.querySelector('.header');
    if (header) {
      header.classList.remove('header--hover-active');
    }
  }

  function initHeaderMegaMenu() {
    var megaMenuBar = document.getElementById('headerMegaMenu');
    var navTriggers = document.querySelectorAll('.header__nav-item--mega[data-mega-trigger]');
    var megaPanels = document.querySelectorAll('.header-mega-menu__panel[data-mega-content]');

    if (!megaMenuBar || navTriggers.length === 0) return;

    var closeTimeout = null;
    var isMenuOpen = false;
    var activeCategory = null;

    function openMenu(category) {
      clearTimeout(closeTimeout);
      isMenuOpen = true;
      activeCategory = category;

      addHeaderHoverActive();

      megaMenuBar.classList.add('is-open');

      var activeTrigger = null;
      navTriggers.forEach(function(trigger) {
        if (trigger.dataset.megaTrigger === category) {
          trigger.classList.add('is-active');
          activeTrigger = trigger;
        } else {
          trigger.classList.remove('is-active');
        }
      });

      var triggerLeft = 0;
      if (activeTrigger) {
        var triggerRect = activeTrigger.getBoundingClientRect();
        triggerLeft = triggerRect.left;
      }

      megaPanels.forEach(function(panel) {
        if (panel.dataset.megaContent === category) {
          panel.classList.add('is-active');
          panel.style.paddingLeft = triggerLeft + 'px';
        } else {
          panel.classList.remove('is-active');
        }
      });
    }

    function closeMenu() {
      closeTimeout = setTimeout(function() {
        isMenuOpen = false;
        activeCategory = null;
        megaMenuBar.classList.remove('is-open');
        navTriggers.forEach(function(trigger) {
          trigger.classList.remove('is-active');
        });
        megaPanels.forEach(function(panel) {
          panel.classList.remove('is-active');
        });
        removeHeaderHoverActive();
      }, 150);
    }

    function cancelClose() {
      clearTimeout(closeTimeout);
    }

    navTriggers.forEach(function(trigger) {
      trigger.addEventListener('mouseenter', function() {
        var category = this.dataset.megaTrigger;
        openMenu(category);
      });

      trigger.addEventListener('mouseleave', function() {
        closeMenu();
      });
    });

    megaMenuBar.addEventListener('mouseenter', function() {
      cancelClose();
    });

    megaMenuBar.addEventListener('mouseleave', function() {
      closeMenu();
    });

    navTriggers.forEach(function(trigger) {
      trigger.addEventListener('mouseenter', function() {
        if (isMenuOpen) {
          var category = this.dataset.megaTrigger;
          if (category !== activeCategory) {
            openMenu(category);
          }
        }
      });
    });
  }

  var desktopMegaMenuInitialized = false;

  function initDesktopMegaMenu() {
    var categoryItems = document.querySelectorAll('.mobile-menu__category-item[data-category]');
    var subcategoryPanels = document.querySelectorAll('.mobile-menu__subcategory-panel[data-subcategory]');
    var featuredPanels = document.querySelectorAll('.mobile-menu__featured-panel[data-featured]');

    if (categoryItems.length === 0) return;

    var firstCategory = categoryItems[0];
    if (firstCategory) {
      var categoryName = firstCategory.dataset.category;
      activateCategory(categoryName);
    }

    if (!desktopMegaMenuInitialized) {
      categoryItems.forEach(function(item) {
        item.addEventListener('mouseenter', function() {
          var categoryName = this.dataset.category;
          activateCategory(categoryName);
        });

      });
      desktopMegaMenuInitialized = true;
    }

    function activateCategory(categoryName) {
      categoryItems.forEach(function(cat) {
        if (cat.dataset.category === categoryName) {
          cat.classList.add('is-active');
        } else {
          cat.classList.remove('is-active');
        }
      });

      subcategoryPanels.forEach(function(panel) {
        if (panel.dataset.subcategory === categoryName) {
          panel.classList.add('is-active');
        } else {
          panel.classList.remove('is-active');
        }
      });

      featuredPanels.forEach(function(panel) {
        if (panel.dataset.featured === categoryName) {
          panel.classList.add('is-active');
        } else {
          panel.classList.remove('is-active');
        }
      });
    }
  }

  function initMobilePanelNavigation() {
    var mobileMenu = document.querySelector('.mobile-menu');
    if (!mobileMenu) return;

    var menuPanels = mobileMenu.querySelectorAll('.mobile-menu__panel');
    var menuItemsWithChildren = mobileMenu.querySelectorAll('.mobile-menu__mobile-layout .mobile-menu__item--has-children');
    var menuBackButtons = mobileMenu.querySelectorAll('.mobile-menu__back');

    menuItemsWithChildren.forEach(function(item) {
      item.addEventListener('click', function(e) {
        e.stopPropagation();
        var targetPanel = item.dataset.target;
        var currentPanel = item.closest('.mobile-menu__panel');
        var nextPanel = mobileMenu.querySelector('[data-panel="' + targetPanel + '"]');

        if (currentPanel && nextPanel) {
          currentPanel.classList.remove('mobile-menu__panel--active');
          nextPanel.classList.add('mobile-menu__panel--active');
        }
      });
    });

    menuBackButtons.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.stopPropagation();
        var targetPanel = btn.dataset.back;
        var currentPanel = btn.closest('.mobile-menu__panel');
        var prevPanel = mobileMenu.querySelector('[data-panel="' + targetPanel + '"]');

        if (currentPanel && prevPanel) {
          currentPanel.classList.remove('mobile-menu__panel--active');
          prevPanel.classList.add('mobile-menu__panel--active');
        }
      });
    });
  }

  function initMegaMenu() {
    var menuToggle = document.querySelector('.header__menu-toggle');
    var mobileMenu = document.querySelector('.mobile-menu');
    var mobileMenuClose = mobileMenu ? mobileMenu.querySelector('.mobile-menu__close') : null;

    if (!menuToggle || !mobileMenu) return;

    menuToggle.addEventListener('mouseenter', function() {
      addHeaderHoverActive();
    });

    menuToggle.addEventListener('mouseleave', function() {
      if (!mobileMenu.classList.contains('is-open')) {
        removeHeaderHoverActive();
      }
    });

    menuToggle.addEventListener('click', function() {
      mobileMenu.classList.add('is-open');
      menuToggle.classList.add('is-active');
      document.body.style.overflow = 'hidden';
      addHeaderHoverActive();

      var menuPanels = mobileMenu.querySelectorAll('.mobile-menu__panel');
      menuPanels.forEach(function(panel) {
        panel.classList.remove('mobile-menu__panel--active');
      });
      var mainPanel = mobileMenu.querySelector('[data-panel="main"]');
      if (mainPanel) {
        mainPanel.classList.add('mobile-menu__panel--active');
      }

      initDesktopMegaMenu();
    });

    var closeMenu = function() {
      mobileMenu.classList.remove('is-open');
      menuToggle.classList.remove('is-active');
      document.body.style.overflow = '';
      removeHeaderHoverActive();
    };

    if (mobileMenuClose) {
      mobileMenuClose.addEventListener('click', closeMenu);
    }

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && mobileMenu.classList.contains('is-open')) {
        closeMenu();
      }
    });

    mobileMenu.querySelectorAll('a').forEach(function(link) {
      link.addEventListener('click', function() {
        closeMenu();
      });
    });

    mobileMenu.addEventListener('click', function(e) {
      var interactiveSelectors = [
        '.mobile-menu__close',
        '.mobile-menu__logo',
        '.mobile-menu__col',
        '.mobile-menu__panel',
        '.mobile-menu__nav',
        '.mobile-menu__item',
        '.mobile-menu__category-item',
        '.mobile-menu__sub-item',
        '.mobile-menu__simple-item',
        '.mobile-menu__back',
        '.mobile-menu__title',
        '.mobile-menu__label',
        '.mobile-menu__featured-item',
        'a',
        'button'
      ];

      var isInteractive = interactiveSelectors.some(function(selector) {
        return e.target.closest(selector);
      });

      if (!isInteractive) {
        closeMenu();
      }
    });
  }

  function init() {
    initMegaMenu();
    initMobilePanelNavigation();
    initDesktopMegaMenu();
    initHeaderMegaMenu();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
